import i18n from "../lang/i18n";
import moment from "moment";

export function formatPrice(value) {
  let val = (value / 1).toFixed(0).replace(".", ",");
  return (
    val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") +
    " " +
    i18n.t("common.VND")
  );
}

export function formatNumber(value) {
  if (!value) return 0;
  let fractionDigits = value % 1 !== 0 ? 1 : 0;
  let val = (value / 1).toFixed(fractionDigits);
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function formatTimeAgo(value) {
  return value ? moment(new Date(value)).fromNow() : "";
}

export function formatDateAndTime(value) {
  return value
    ? moment(new Date(value), "DD/MM/YYYY HH:mm:ss").format(
        "DD/MM/YYYY HH:mm:ss"
      )
    : null;
}

export function formatIntToFloat(value) {
  return value ? value.toFixed(1) : null;
}
